export class Role {
    constructor(name, extendRole, app) {
        this.name = name;
        this.extendRole = extendRole;
        this.app = app;
    }
    async optain(arg) {
        return false;
    }
}
export class User extends Role {
    constructor(app) {
        super("user", null, app);
    }
    async optain() {
        //role user is availble for everyone
        return true;
    }
}
export class Merchant extends Role {
    constructor(app) {
        super("merchant", new User(app), app);
    }
    async optain({ email, pass, }) {
        if (!email || !pass) {
            return false;
        }
        const isVerified = await this.app.connection.openUserOperations.verifyUser(email.toString(), pass.toString());
        if (isVerified == "verified")
            return new VerifiedMerchant(this.app);
        return isVerified == "true" ? true : false;
    }
}
Merchant.extend = "user";
export class VerifiedMerchant extends Role {
    constructor(app) {
        super("verifiedMerchant", new Merchant(app), app);
    }
    async optain({ email, pass }) {
        if (!email || !pass) {
            return false;
        }
        return await this.app.connection.openUserOperations.verifyUserWithEmail(email, pass);
    }
}
VerifiedMerchant.extend = "merchant";
export class Admin extends Role {
    constructor(app) {
        super("admin", new VerifiedMerchant(app), app);
    }
}
Admin.extend = "verifiedMerchant";
export class Owner extends Role {
    constructor(app) {
        super("owner", new Admin(app), app);
    }
}
Owner.extend = "admin";
const roles = {
    user: {
        name: "user",
        extend: null,
        isDefault: true,
    },
    merchant: {
        name: "merchant",
        extend: "user",
    },
    verifiedMerchant: {
        name: "verifiedMerchant",
        extend: "merchant",
    },
    admin: {
        name: "admin",
        extend: "verifiedMerchant",
    },
    owner: {
        name: "owner",
        extend: "admin",
    },
};
export class RoleChecker {
    constructor(session) {
        this.session = session;
    }
    assignRole(role, email) {
        this.session["permsLevel"] = role.name;
        this.session["email"] = email;
    }
    hasRole(neededRole, currentRole) {
        var _a;
        if (roles[neededRole].isDefault == true)
            return true;
        if (!currentRole)
            return false;
        if (neededRole === currentRole)
            return true;
        if ((_a = roles[currentRole]) === null || _a === void 0 ? void 0 : _a.extend)
            return this.hasRole(neededRole, roles[currentRole].extend);
        return false;
    }
    async has(role) {
        if (this.session) {
            return this.hasRole(role.name, this.session["permsLevel"]);
        }
        return false;
    }
    async optain(neededRole, additional) {
        const result = await neededRole.optain(additional !== null && additional !== void 0 ? additional : {});
        if (result instanceof Role) {
            this.assignRole(result, additional === null || additional === void 0 ? void 0 : additional.email);
            return true;
        }
        if (result)
            this.assignRole(neededRole, additional === null || additional === void 0 ? void 0 : additional.email);
        return result;
    }
    refreshSession() {
        return new Promise((resolve, reject) => {
            const oldSessionData = JSON.parse(JSON.stringify(this.session));
            delete oldSessionData.cookie;
            this.session.regenerate((err) => {
                if (err)
                    reject(err);
                //so hacky, that I don't know how to do it, so I just disabled typescript
                // @ts-expect-error
                const entries = Object.entries(oldSessionData);
                resolve(entries);
            });
        });
    }
    get userSessions() {
        return this.session;
    }
}
